import type { ComponentSingleStyleConfig } from '@chakra-ui/theme';

export const Icon: ComponentSingleStyleConfig = {
  baseStyle: {
    verticalAlign: '-.125em',
  },
};
